import { Injectable } from '@angular/core';
import { routeEventTime } from '@medlogic/shared/shared-interfaces';
import { FhirGenericService } from './fhir-generic.service';

@Injectable({ providedIn: 'root' })
export class FhirEventTimeService extends FhirGenericService {

  protected url = routeEventTime;

}
